import Pagination from 'antd/es/pagination';
import 'antd/lib/pagination/style';
export default Pagination;
